import React from 'react';
import { GetCopy } from '../util/GetCopy';
import { ReactComponent as Check } from '../../src/img/check.svg';
import { useAppState } from '../context/State';
const ToggleButton = ({ setNextAdIndex, setSelectedFormat }) => {
  const state = useAppState();
  const options = ['Display', 'Video'];
  const handleToggle = () => {
    state.setActiveOption((prevOption) => (prevOption === 'Display' ? 'Video' : 'Display'));
    setNextAdIndex(9);
  };

  return (
    <button onClick={handleToggle} className="toggleButton">
      {options.map((text) => (
        <span key={text} className={state.activeOption === text ? 'active' : null}>
          {state.activeOption === text && <Check className="checkmark" />}
          <GetCopy copy={text.toLocaleLowerCase()} />
        </span>
      ))}
    </button>
  );
};

export default ToggleButton;
